import {
    CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE,
    CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE,
    CertificatesExpandedParamsModalFieldConfig,
} from 'common.components/certificates-expanded-params-modal/typings';

export const CERTIFICATES_EXPANDED_PARAMS_MODAL_CONFIG: CertificatesExpandedParamsModalFieldConfig[] = [
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.FULL_NAME,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
        required: true,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.LOCALITY,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
        required: true,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.SCHOOL,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
        required: true,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.NEED_PAPER_VARIANT,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO,
        required: true,
        options: {
            choices: [
                'certificatesExpandedParamsModal.formField.need_paper_variant.choices.agree',
                'certificatesExpandedParamsModal.formField.need_paper_variant.choices.disagree',
            ],
        },
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.RESIDENCE_ADDRESS,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.SNLS,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
        required: true,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.DATE_OF_BIRTH,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.DATE,
        required: true,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.GENDER,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO,
        required: true,
        options: {
            choices: [
                'certificatesExpandedParamsModal.formField.gender.choices.male',
                'certificatesExpandedParamsModal.formField.gender.choices.female',
            ],
        },
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.CITIZENSHIP_RU,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO,
        options: {
            choices: [
                'certificatesExpandedParamsModal.formField.citizenship_ru.choices.agree',
                'certificatesExpandedParamsModal.formField.citizenship_ru.choices.disagree',
            ],
        },
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.CITIZENSHIP_OTHERS,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT,
    },
    {
        infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE.HAS_HIGHER_EDUCATION,
        inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO,
        required: true,
        options: {
            choices: [
                'certificatesExpandedParamsModal.formField.has_higher_education.choices.agree',
                'certificatesExpandedParamsModal.formField.has_higher_education.choices.disagree',
            ],
        },
    },
];
